// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"134":"CardThree","397":"CardFour","480":"CardOne","489":"NftCarousel","827":"CardTwo","888":"CardsListView"}[chunkId] + ".css";
};